<template>
  <div id="introduction-to-mortgagewatch">
    <HeroSection :size="size" :theme="theme">
      <!-- Icon Blocks Section -->
      <div v-if="!hideTitle" class="text-center mb-6">
        <h1 class="text-navy font-size-4">{{ title }}</h1>
        <div class="w-lg-75 w-sm-100 m-auto">
          <h4 class="text-navy font-size-2 mt-3">We can help to find a better fixed-term mortgage deal before your current deal expires!</h4>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-lg-2 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-9.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Your goals</h4>
            <p class="font-size-1">Tell us about your remortgage goals and so we can monitor the market on your behalf.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-lg-2 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-11.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Sit back &amp; relax</h4>
            <p class="font-size-1">As the end of your current deal draws closer, we'll search the market and alert you to the best deals.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-lg-2 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-42.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Explore deals</h4>
            <p class="font-size-1">Compare the deals to find the right one for you - to help we'll highlight the best savings.</p>
          </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 mb-3 mb-lg-2 mb-sm-5">
          <!-- Icon Blocks -->
          <div class="text-center px-lg-3">
            <figure class="max-w-13rem mx-auto mb-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-27.svg" alt="SVG">
            </figure>
            <h4 class="text-navy">Remortgage &amp; save</h4>
            <p class="font-size-1">Found the deal you want? Apply online, via your favourite broker or direct with the Lender.</p>
          </div>
        </div>
      </div>
      <div v-if="!hideTitle" class="text-center mb-6">
        <div class="w-lg-75 w-sm-95 m-auto">
          <h4 class="text-navy mt-3">If you don't remortgage and secure another fixed-term deal before your current deal expires it could cost you thousands every year.</h4>
        </div>
      </div>

      <div v-if="false" class="row justify-content-lg-center mb-3 pb-3">
        <div class="col-md-12">
        </div>
        <div class="col-md-6 col-lg-5 mb-3 mb-md-7">
          <!-- Icon Blocks -->
          <div class="media pr-lg-5">
            <figure class="w-100 max-w-13rem mr-4">
              <img class="img-fluid" :src="tiles['goals'].image" alt="SVG">
            </figure>
            <div class="media-body">
              <h4 class="text-navy">{{ tiles["goals"].title }}</h4>
              <p class="font-size-1">{{ tiles["goals"].summary }}</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-6 col-lg-5 mb-3 mb-md-7">
          <!-- Icon Blocks -->
          <div class="media pl-lg-5">
            <figure class="w-100 max-w-13rem mr-4">
              <img class="img-fluid" :src="tiles['relax'].image" alt="SVG">
            </figure>
            <div class="media-body">
              <h4 class="text-navy">{{ tiles["relax"].title }}</h4>
              <p class="font-size-1">{{ tiles["relax"].summary }}</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="w-100"></div>

        <div class="col-md-6 col-lg-5 mb-3 mb-md-7 mb-lg-0">
          <!-- Icon Blocks -->
          <div class="media pr-lg-5">
            <figure class="w-100 max-w-13rem mr-4">
              <img class="img-fluid" :src="tiles['explore'].image" alt="SVG">
            </figure>
            <div class="media-body">
              <h4 class="text-navy">{{ tiles["explore"].title }}</h4>
              <p class="font-size-1">{{ tiles["explore"].summary }}</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-6 col-lg-5">
          <!-- Icon Blocks -->
          <div class="media pl-lg-5">
            <figure class="w-100 max-w-13rem mr-4">
              <img class="img-fluid" :src="tiles['save'].image" alt="SVG">
            </figure>
            <div class="media-body">
              <h4 class="text-navy">{{ tiles["save"].title }}</h4>
              <p class="font-size-1">{{ tiles["save"].summary }}</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>
      </div>
      <div v-if="customCta" class="text-center mt-4 mb-8">
        <button class="btn btn-soft-primary" style="min-width: 50%" @click="$emit('clicked')">{{ customCtaText }}</button>
      </div>
      <div v-if="includeCta" class="text-center mt-4 mb-8">
        <router-link
            to="/mortgage-watch/getting-started"
            v-slot="{ href, route, navigate }">
          <button class="btn btn-primary" style="min-width: 50%" :href="href" @click="navigate">Create a MortgageWatch Alert</button>
        </router-link>
      </div>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "IntroductionToMortgageWatch",
  components: {HeroSection},
  
  data() {
    return {
      tiles: {
        "goals": {
          image: "/assets/svg/icons/icon-9.svg",
          title: "Your goals",
          summary: "Tell us about your remortgage goals and so we can monitor the market on your behalf."
        },
        "relax": {
          image: "/assets/svg/icons/icon-11.svg",
          title: "Sit back & relax",
          summary: "As the end of your current deal draws closer, we'll search the market and alert you to the best deals."
        },
        "explore": {
          image: "/assets/svg/icons/icon-42.svg",
          title: "Explore deals",
          summary: "Compare the deals to find the right one for you - to help we'll highlight the best savings."
        },
        "save": {
          image: "/assets/svg/icons/icon-27.svg",
          title: "Remortgage & save",
          summary: "Found the deal you want? Apply online, via your favourite broker or direct with the Lender."
        }
      }
    }
  },
  
  props: {
    theme: {
      type: String,
      default: "home/introduction"
    },
    title: {
      type: String,
      default: "Is your fixed-term deal coming to an end?"
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    includeCta: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    },
    customCta: {
      type: Boolean,
      default: false
    },
    customCtaText: {
      type: String,
      default: "Custom CTA (click me!)"
    }
  }
};
</script>
